const {useState,useEffect} = wp.element;
const apiFetch=wp.apiFetch;
const {addQueryArgs}=wp.url;
import Async, { useAsync } from 'react-select/async';

import AsyncSelect from 'react-select/async';


export  default function School() {

    const schoolCat=[
        {id:1,name:"大学"},
        {id:2,name:"短大"},
        {id:3,name:"専門学校"},
        {id:0,name:"クリアー"},
        ];
    const baseURL="/school/v2/school_point/";
    const facultyParentURL="/faculty_parent/v2/faculty_parent_point/";
    const facultyChildURL="/faculty_child/v2/faculty_child_point/";
    const technicalURL="/technical_faculty/v2/technical_faculty_point/";

    const [cat,setCat] = useState("");
    const [schools,setSchools] = useState([]);
    const [defaultSchool,setDefaultSchool] = useState([]);
    const [facultyParent, setFacultyParent] = useState([]);
    const [facultyParentId, setFacultyParentId] = useState("");
    const [facultyChild, setFacultyChild] = useState([]);
    const [technical, setTechnical] = useState([]);



    let student_school=null;
    let student_school_cat=null;
    let parent_faculty_cat=null;
    let faculty_cat=null;
    const user_school = typeof window !== 'undefined' &&
    window.user_school ? window.user_school : {
        student_school:null,
        student_school_cat:null,
        parent_faculty_cat:null,
        faculty_cat:null,

    };

    student_school = user_school.student_school?user_school.student_school:0;
    student_school_cat = user_school.student_school_cat?user_school.student_school_cat:0;
    parent_faculty_cat = user_school.parent_faculty_cat?user_school.parent_faculty_cat:0;
    faculty_cat = user_school.faculty_cat?user_school.faculty_cat:0;
    if(student_school && student_school_cat) {
        useEffect(() => {
           getSchoolCurrentData(student_school);
           setCat(student_school_cat);
           // student_school=null;
           // student_school_cat=null;

        },[]);

    }
    if((student_school_cat=="1"|| student_school_cat=="2") && parent_faculty_cat){
        useEffect(() => {
            getFacultyParentCurrentData(parent_faculty_cat);
            getFacultyChildCurrentData(faculty_cat);


            // student_school=null;
            // student_school_cat=null;

        },[]);
    }

    if(student_school_cat=="3" && faculty_cat){
        useEffect(() => {
            getTechnicalCurrentData(faculty_cat);


            // student_school=null;
            // student_school_cat=null;

        },[]);

    }

        function getSchoolCurrentData(id){
        const apiUrlWithParams = addQueryArgs(baseURL, {id: id});
        apiFetch({
            path: apiUrlWithParams,
        }).then((data) => {
            const d=data.map((item)=>{
                    return {value:item.id,label:item.name}
                }
            );
            setDefaultSchool(d);
            setSchools(d);
        });
    }
    function getFacultyParentCurrentData(id){
        const apiUrlWithParams = addQueryArgs(facultyParentURL, {id: id});
        apiFetch({
            path: apiUrlWithParams,
        }).then((data) => {
            const d=data.map((item)=>{
                    return {value:item.id,label:item.name}
                }
            );
            setFacultyParent(d);
        });

    }
    function getFacultyChildCurrentData(id){
        const apiUrlWithParams = addQueryArgs(facultyChildURL, {id: id});
        apiFetch({
            path: apiUrlWithParams,
        }).then((data) => {
            const d=data.map((item)=>{
                    return {value:item.id,label:item.name}
                }
            );
            setFacultyChild(d);
        });
    }
    function getTechnicalCurrentData(id){
        const apiUrlWithParams = addQueryArgs(technicalURL, {id: id});
        apiFetch({
            path: apiUrlWithParams,
        }).then((data) => {
            const d=data.map((item)=>{
                    return {value:item.id,label:item.name}
                }
            );
            setTechnical(d);
        });
    }
    const handleChange = (e) => {

            setDefaultSchool(e);

    }

    const filterColors = (inputValue) => {
        return schools.filter((i) =>

            i.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const promiseOptions = (inputValue) =>
        new Promise((resolve) => {
            setTimeout(() => {
                resolve(filterColors(inputValue));
            }, 1000);
        });
function handleOnChangeCat(e){

        setCat(e.target.value);
    const apiUrlWithParams = addQueryArgs(baseURL, {school_id: e.target.value});
    if(e.target.value==1 || e.target.value==2){

        const apiFacultyParentURLParams = facultyParentURL;
        apiFetch({
            path: apiFacultyParentURLParams,
        }).then((data) => {

            const d=data.map((item)=>{
                    return {value:item.id,label:item.name}
                }
            );
            setDefaultSchool([]);
            setFacultyChild([]);
            setTechnical([]);
            setFacultyParent(d);
        });


    }else if(e.target.value==3){

        apiFetch({
            path: technicalURL,
        }).then((data) => {
            const d=data.map((item)=>{
                    return {value:item.id,label:item.name}
                }
            );
            setDefaultSchool([]);
            setFacultyChild([]);
            setFacultyParent([]);

            setTechnical(d);
        });

    }

    if(e.target.value==0){

        setSchools([]);
        setFacultyParent([]);
        setFacultyChild([]);
        setTechnical([]);
        setDefaultSchool([]);



        return;
    }
    apiFetch({
        path: apiUrlWithParams,
    }).then((data) => {
        const d=data.map((item)=>{
            return {value:item.id,label:item.name}
        }
        );

        setSchools(d);
    });



}

function handleChangeFacultyParent(e){
    const apiUrlWithParams = addQueryArgs(facultyChildURL, {parent_id: e.target.value});
        apiFetch({
            path: apiUrlWithParams,
        }).then((data) => {
            const d=data.map((item)=>{
                    return {value:item.id,label:item.name}
                }
            );

            setFacultyChild(d);
        });
}

    return(
        <div className="school school_cat">
            <label htmlFor=""><span>学校を選択</span></label>
            {schoolCat.map((item)=> {
                const cehcked = cat == item.id ? true : false;

                    return (
                        <label htmlFor={`school_cat_${item.id}`} className="d-flex">
                            <input id={`school_cat_${item.id}`} type="radio" name="student_school_cat" value={item.id}
                                      checked={cehcked}
                                   onChange={handleOnChangeCat}/>
                            {item.name}
                        </label>
                    )
                }
            )}

            <AsyncSelect
                cacheOptions
               value={defaultSchool}
                loadOptions={promiseOptions}
                name="student_school"
                defaultOptions={schools}
                placeholder="入力文字で検索する"
                onChange={handleChange}
                required={true}

            />
            {(cat==1 || cat==2) &&
            <div className="faculty faculty_section">
                <label htmlFor=""><span>学部の選択</span></label>
                <select name="parent_faculty_cat" id="" onChange={handleChangeFacultyParent} required={true}>
                    <option value="">選択してください</option>
                    {facultyParent && facultyParent.map((item)=> {
                        return <option value={item.value} selected={parent_faculty_cat==item.value?true:false}>{item.label}</option>
                    })
                    }
                </select>
                <label htmlFor=""><span>学科の選択</span></label>
                <select name="faculty_cat" id="" required={true}>

                    {facultyChild && facultyChild.map((item)=> {

                        return <option value={item.value} selected={faculty_cat==item.id?true:false}>{item.label}</option>
                    })
                    }
                </select>



            </div>
            }

            {cat==3 &&
                <div className="faculty_section">
                    <label htmlFor=""><span>学科</span></label>
                    <select name="faculty_cat" id="" required={true}>
                        {technical && technical.map((item)=> {
                            return <option value={item.value}>{item.label}</option>
                        })

                        }
                </select>
                </div>

            }


</div>
    )
}